<template>
   <bootstrap-collapse :visible="visible">
    <b-card-text>
      <b-card-title class="h3 mb-0">Filtro de Clientes</b-card-title>
      <div class="col-lg-12" style="text-align: right;"></div>

      <b-row>
        <b-col md="12">
          <div class="pt-3 pb-2">{{ selectTitle }}</div>
          <multiselect 
            :multiple="true" 
            :hide-selected="false" 
            :clear-on-select="false" 
            :close-on-select="false"
            placeholder="Pesquisar..." 
            deselect-label="Remover" 
            select-label="Adicionar" 
            selected-label="Selecionado"
            :searchable="true"
            v-model="selectedOptions" 
            :options="selectOptions">
          </multiselect>
        </b-col>
      </b-row>
    </b-card-text>
  </bootstrap-collapse>
</template>
  
<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";

export default {
  name: "filter-selected-service-monitor",

  props: {
    visible: { type: Boolean, default: true },

    resetFilter: { type: Boolean, default: false, },

    selectTitle: { type: String, default: "", },

    selectOptions: { type: Array, default: [] },

    selectOptionsToPreserve: { type: Array, default: [] },
  },

  components: {
    BootstrapCollapse,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col
  },

  watch: {
    selectedOptions(novo, old) { this.$emit('selectedClients', Object.values(novo)) },

    resetFilter(newValue, oldValue){ if(newValue == true){ this.selectedOptions = []; this.$emit('rebootedFilter', false) } },

    selectOptionsToPreserve(newValue, oldValue){
      if(newValue.length == 0){ this.selectedOptions = []; }
    },

  },

  data() {
    return {
      selectedOptions: [],
    };
  },

  mounted(){
    if(this.selectOptionsToPreserve.length > 0){
      var vm = this
      this.selectOptionsToPreserve.map(function(value, index){
        if(vm.selectOptions.includes(value)){ vm.selectedOptions.push(value) }
      })
    }
    else if(this.selectOptionsToPreserve.length == 0){
      this.selectedOptions = []
    }
  },

  methods: {
  }

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
